export default __webpack_public_path__ + "static/media/casey2.51f8e9cc.png";